import React from "react";
import ReactDOM from "react-dom";
import "./styles.css";
import App from "./pages/App";
import * as serviceWorker from "./serviceWorker";
import UserProvider from "./providers/UserProvider";

ReactDOM.render(
  <React.StrictMode>
    <UserProvider>
      <App />
    </UserProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
